import { useState } from 'react'

const usePagination = (initialPage: number, initialRowsPerPage: number) => {
  const [page, setPage] = useState(initialPage)
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage)

  return { page, setPage, rowsPerPage, setRowsPerPage }
}

export { usePagination }
